const FIRST_NAME_MAX = 50;
const LAST_NAME_MAX = 50;

/**
 * Validation limits for onboarding fields
 * Centralized constants to ensure consistency across validation rules
 */
export const VALIDATION_LIMITS = {
  /**
   * Longest accepted email address. Matches the `users.email` column and
   * the @MaxLength on every identity input that accepts one (register,
   * login, register-with-role, create-test-user) plus the partner invite
   * input — those still carry the literal and should adopt this constant.
   */
  EMAIL_MAX: 255,

  // Name fields
  FIRST_NAME_MIN: 2,
  FIRST_NAME_MAX,
  LAST_NAME_MIN: 2,
  LAST_NAME_MAX,

  /** Longest "Get in touch" message. Enforced by the contact form and by the `ContactInput` GraphQL input. */
  CONTACT_MESSAGE_MAX: 2000,
  /** The contact form joins first and last name with a space. */
  CONTACT_NAME_MAX: FIRST_NAME_MAX + 1 + LAST_NAME_MAX,
  CONTACT_PHONE_MAX: 50,
  CONTACT_REFERRAL_MAX: 200,

  // Admin form fields (deals, courses, scenarios, etc.)
  ADMIN_FORM_TITLE_MAX: 100,

  // Content fields
  /**
   * Shortest accepted content title. Enforced by `TitleField` on every create
   * input and by `UpdateContentInput` on every update, so a title that is
   * accepted on create cannot be refused on edit, or the other way round.
   */
  CONTENT_TITLE_MIN: 3,
  CONTENT_TITLE_MAX: 200,
  CONTENT_DESCRIPTION_MAX: 5000,
  /**
   * How many files one community post may carry. Enforced by the post
   * aggregate and by the post inputs' `ArrayMaxSize`, and applied by the
   * composer before a file is uploaded, so the two cannot drift.
   */
  POST_ATTACHMENTS_MAX: 4,
  CONTENT_SECONDARY_CATEGORIES_MAX: 3,

  // Messaging and customer AI
  CHAT_MESSAGE_MAX: 4000,

  // Professional fields
  JOB_TITLE_MAX: 100,
  COMPANY_NAME_MAX: 100,

  // Text content
  TAGLINE_MAX: 200,
  ABOUT_ME_MIN: 10,
  ABOUT_ME_MAX: 1300,
  MOTIVATION_MIN: 50,
  MOTIVATION_MAX: 1000,
} as const;
